<template>
  <div class="runs-map">

    <div class="map-here" id="RunMapHere"></div>

    <div :class="['map-loader', {hide: !mapLoader.show}]">{{ mapLoader.label }}</div>

    <!-- <div :class="['search-status', {hide: (nearByDrivers.length <= 0 || qualifiedDrivers.list.length || mapLoader.show)}]">
      <span v-if="isQualifiedDriver">
        We found driver(s) for this reservation.
      </span>
      <span v-else>
        We found {{ nearByDrivers.length }} {{ nearByDrivers.length > 1 ? 'drivers' : 'driver' }} within {{ searchStatus.miles }} {{ searchStatus.miles > 1 ? 'miles' : 'mile' }} of the pickup.
      </span>
    </div> -->

    <a :class="['filter-toggle', {open: driverFilter.show, hide: !only1Run(items) /*!driverFilter.showToggle*/}]"
      href="javascript:;" @click="driverFilter.show = !driverFilter.show">
      <i :class="{
        'far fa-times-circle': driverFilter.show,
        'fas fa-sliders-h': !driverFilter.show,
        'fa-fw fa-lg': true
      }"></i>
    </a>

    <div :class="['driver-filters', {hide:!driverFilter.show || !items.length}]">
      <div :class="['cover', {show: driverFilter.isLoading || driverFilter.serviceLoading}]">
        <div class="cover-container">
          <div class="cover-content">
            <pulse-loader></pulse-loader>
            <div class="content">{{ $t('dispatch.map.filterControls.labelLoading') }}</div>
          </div>
        </div>
      </div>

      <div class="message">Use the form below to modify restrictions</div>
      <!-- <div class="message">{{ $t('dispatch.map.filterControls.title') }}</div> -->

      <form class="extend-input" @submit.prevent="driverFilterSubmit">
        <div class="radius-input">
          <input type="number" v-model="driverFilter.miles" />
          <label>{{ $t('dispatch.map.filterControls.labelRadius') }}</label>
        </div>

        <div class="service-types" v-if="!isQualifiedDriver">
          <div class="title">{{ $t('dispatch.map.filterControls.labelServices') }}</div>
          <div class="row">
            <div class="small-12 columns" v-for="service in driverFilter.services" :key="service.id">
              <label>
                <input type="checkbox" :value="service.id" v-model="driverFilter.serviceTypes" />
                <span>{{ service.name }}</span>
              </label>
            </div>
          </div>
        </div>

        <div class="service-types" v-else>
          <div class="title">Qualification Criteria:</div>
          <div class="row">
            <div class="small-12 columns">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.seatCapacity" />
                <span>Seat Capacity Restriction</span>
              </label>
            </div>
            <div class="small-12 columns">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.serviceTypes" />
                <span>Service Types Restriction</span>
              </label>
            </div>
            <div class="small-12 columns">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.adaWC" />
                <span>ADA: Wheelchair Restriction</span>
              </label>
            </div>
            <div class="small-12 columns">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.adaSD" />
                <span>ADA: Service Dog Restriction</span>
              </label>
            </div>
            <div class="small-12 columns" v-if="false">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.fullTNC" />
                <span>License Type Restriction</span>
              </label>
            </div>
            <div class="small-12 columns">
              <label>
                <input type="checkbox" v-model="qualifiedFilter.availability" />
                <span>Availability Restriction</span>
              </label>
            </div>
          </div>
          <div class="filter-note"
            v-if="!qualifiedFilter.seatCapacity || !qualifiedFilter.serviceTypes || !qualifiedFilter.adaWC || !qualifiedFilter.adaSD || !qualifiedFilter.fullTNC || !qualifiedFilter.availability">
            Changing the qualification criteria will also disable the checks for driver's upcoming trip conflicts, tight route, and work hours.
          </div>
        </div>

        <div class="divider"></div>

        <div class="button-wrapper">
          <button class="cta block success">
            {{ $t('dispatch.map.filterControls.labelButton') }}
          </button>
        </div>
      </form>
    </div>

    <div :class="['lr-modal', {'hide': !queueError.show}]">
      <div class="lr-box">
        <div class="lr-alert-msg" v-html="queueError.message"></div>
        <a class="button cta small right block" @click="showReasons">View Driver Qualification Checks</a>
        <div class="show-reasons-btn" @click="queueError.show = false">Dismiss</div>
      </div>
    </div>
    <!-- <div :class="['lr-modal reasons-modal', {'hide': !queueError.reasonsModal}]">
      <div class="lr-box">
        <table class="reason-table" cellpadding="5" cellspacing="0">
          <thead>
            <th class="driver">Driver</th>
            <th class="reason">Reason</th>
          </thead>
          <tbody>
            <tr v-for="qe in queueError.list">
              <td class="driver"><a :href="'/#/provider/' + qe.id" target="_blank">{{ qe.name }}</a></td>
              <td class="reason">{{ reasonLabel(qe.reason) }}</td>
            </tr>
          </tbody>
        </table>
        <a class="button cta small right block" @click="closeReasons">Close</a>
      </div>
    </div> -->

  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import moment from 'moment'
import mapSettings from '@/values/map-settings'
import mapPins from '@/values/map-pin'
import services from '@/modules/api/services'
import PulseLoader from '@/components/Partials/LoadingAnimation/Pulse'

import _MapMarkerUtils from './_map-marker-utils'
import _MapUtils from './_map-utils'

import ApiDispatchDrivers from '@/modules/api/dispatch/drivers'
import ft from '@/modules/api/featureToggle'

export default {
  name: 'runs-table',
  components: { PulseLoader },
  data () {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      ids: {
        map: 'RunMapHere'
      },
      mapOptions: mapSettings,
      pickupPin: mapPins.pickup,
      dropoffPin: mapPins.dropoff,
      mapPins: [],
      infoWindows: [],
      route: [],
      routes: [],
      center: { lat: 33.942791, lng: -118.410042 },

      current: {
        driversInMap: [],
        nearbyDrivers: [],
        openDriver: ''
      },
      driverDistance: [],
      showDriverInfoWindow: false,
      driverInfoIndex: 0,
      driverPresentation: false,
      driverPresented: [],
      delayBeginDriverPresentation: '',
      mapLoader: {
        show: false,
        label: 'LOADING RESERVATION...'
      },
      waiting: {
        renderDriver: {
          data: '',
          process: false
        },
        beginDriverPresentation: false
      },
      searchStatus: { miles: 10 },
      driverFilter: {
        showToggle: false,
        show: false,
        isLoading: false,
        miles: 10,
        serviceTypes: [],
        services: [],
        serviceLoading: false
      },
      driverRoutes: {},
      upcoming: {
        loading: false,
        rsvp: null
      },
      lastServiceAvailableCheck: {
        id: 0,
        date: moment()
      },
      isQualifiedDriver: false,
      qualifiedFilter: {
        serviceTypes: 1,
        seatCapacity: 1,
        adaWC: 1,
        adaSD: 1,
        fullTNC: 1,
        availability: 1,
      },
      queueError: {
        show: false,
        message: ''
      },
      lastDriverType: '',
      sendTimerDelay: '',
      doubleFix: false,
      currentDriver: null
    }
  },
  computed: {
    runs () { return this.$store.state.runs },
    items () { return this.runs.dropzone.items },
    dispatch () { return this.$store.state.dispatch },
    rsvpAvailabilityLoading: {
      get () { return this.dispatch.availableDrivers.loading },
      set (x) { this.$store.commit('dispatch/setAvailableDriversData', {loading: x})}
    },
    rsvpAvailableDrivers () { return this.dispatch.availableDrivers.list },
    nearByDrivers () { return this.runs.nearByDrivers.list },
    runsInMap () { return this.runs.other.runsInMap },
    qualifiedDrivers () { return this.runs.qualifiedDriver }
  },
  methods: {
    initMap () {
      let self = this
      let mapContainer = document.getElementById(self.ids.map)
      self.hereMaps.platform = new window.H.service.Platform({apikey: CONFIG.hereApi.key})

      let defaultLayers = self.hereMaps.platform.createDefaultLayers()
      self.hereMaps.map = new window.H.Map(mapContainer,
        defaultLayers.vector.normal.map, {
          center: self.center,
          zoom: 13,
          pixelRatio: window.devicePixelRatio || 1
        }
      )

      /* eslint-disable no-unused-vars */
      let behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map))
      /* eslint-enable no-unused-vars */
      self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers)
    },
    renderMarkers () {
      let self = this
      let bounds = []
      _MapUtils.clearMap(self.hereMaps.map)
      for (let i = 0; i < self.items.length; i++) {
        let item = self.items[i]

        _MapMarkerUtils.drawPoiMarker (self.hereMaps.map, 'pickup_' + item.id, item.pickup, 'pickup')
        _MapMarkerUtils.drawPoiMarker (self.hereMaps.map, 'dropoff_' + item.id, item.dropoff, 'dropoff')
        bounds.push(item.pickup)
        bounds.push(item.dropoff)
      }

      setTimeout(() => {
        _MapUtils.setBounds(self.hereMaps.map, bounds, 0.4) 
      }, 400)
    },
    computeRoute () {
      let self = this

      let url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary'
      url = url.replace('{API_KEY}', CONFIG.hereApi.key)

      let waypoints = []
      for (let i = 0; i < self.items.length; i++) {
        waypoints.push(self.items[i].pickup)
        waypoints.push(self.items[i].dropoff)
      }

      waypoints.forEach((coords, index) => {
        if (index == 0) {
          url += `&origin=${coords.lat},${coords.lng}`
        } else if (index == waypoints.length - 1) {
          url += `&destination=${coords.lat},${coords.lng}`
        } else {
          url += `&via=${coords.lat},${coords.lng}`
        }
      })

      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('ROUTING ERROR', error)
          return
        }
        
        // _MapUtils.removeObject(self.hereMaps.map, 'RUN_ROUTE')
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id.indexOf('RUN_ROUTE') > -1) {
            self.hereMaps.map.removeObject(object)
          }
        }
        if (!body.routes.length) return
        body.routes[0].sections.forEach((route, index) => {
          let linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
          let polyline = new window.H.map.Polyline(linestring, {
            style: {
              lineWidth: 3,
              strokeColor: '#333',
              lineTailCap: 'arrow-tail',
              lineHeadCap: 'arrow-head'
            }
          })
          let polylineArrow = new window.H.map.Polyline(linestring, {
            style: {
              lineWidth: 2,
              fillColor: 'white',
              strokeColor: 'rgba(255, 255, 255, 1)',
              lineDash: [0, 3],
              lineTailCap: 'arrow-tail',
              lineHeadCap: 'arrow-head'
            }
          })
          let routeLine = new window.H.map.Group()
          routeLine.addObjects([polyline, polylineArrow])
          routeLine.id = `RUN_ROUTE${index}`
          self.hereMaps.map.addObject(routeLine)
        })

        self.updateTravelTimes(body.routes[0].sections)
      })
    },
    updateTravelTimes (legs) {
      let self = this
      // even index = reservation
      // odd index = connection times
      let resTimes = []
      let connections = []
      for (let i = 0; i < legs.length; i++) {
        let leg = legs[i].summary
        let distance = 0
        let travelTime = 0
        // for (let j = 0; j < leg.maneuver.length; j++) {
        //   let maneuver = leg.maneuver[j]
        //   distance += maneuver.length
        //   travelTime += maneuver.travelTime
        // }
        distance += leg.length
        travelTime += leg.duration
        // convert meters to miles
        distance = distance * 0.000621371
        if ((i % 2) === 0) {
          resTimes.push({
            distance: distance,
            eta: travelTime
          })
          continue
        }
        connections.push({
          distance: distance,
          eta: travelTime
        })
      }

      let now = moment(self.items[0].pickupDate, 'MM/DD/YYYY hh:mmA')
      for (let i = 0; i < self.items.length; i++) {
        let resTime = resTimes[i]
        let connection = null
        if (i < connections.length) {
          connection = connections[i]
        }

        let pickupTime = moment(now)

        let timeToNext = connection !== null ? connection.eta : null
        if (timeToNext) {
          // timeToNext += 60 * 10 // add 10mins to ETA
        }
        let result = {
          index: i,
          newPickupTime: pickupTime,
          newEta: resTime.eta,
          timeToNext: timeToNext,
          distanceToNext: connection !== null ? connection.distance : null
        }

        self.$store.commit('runs/updateDropzoneItem', result)
        if (connection !== null) {
          now = moment(now).add(connection.eta, 'seconds')
        }
      }
    },
    getAvailableDrivers (data) {
      if (!data.id) return
      if (data.status !== 'UPCOMING' && data.status !== 'REQUIRES DISPATCH') return

      let self = this
      if (self.rsvpAvailabilityLoading) return
      self.rsvpAvailabilityLoading = true
      self.lastServiceAvailableCheck = {
        id: data.id,
        date: moment()
      }

      let since = moment(data.pickupTime, 'MM/DD/YYYY hh:mmA').format('X')
      let until = moment(data.pickupTime, 'MM/DD/YYYY hh:mmA').add(data.etaInSec || 0, 'seconds').format('X')
      if (data.lastDropoff) {
        until = moment(data.lastDropoff, 'MM/DD/YYYY hh:mmA').format('X')
      }
      self.$sdk.get('/shifts/dashboard', {
        token: self.$store.state.session.sessionToken,
        assignments: 0,
        order: 'startShift',
        orderAsc: 1,
        pageNum: 1,
        sectorId: 0,
        serviceTypeId: data.serviceId,
        since: since,
        until: until
      }, res => {
        self.rsvpAvailabilityLoading = false
        if (res.error) {
          return
        }
        let drivers = []
        res.list.forEach(driver => {
          let name = driver.businessName || `${driver.firstName} ${driver.lastName}`
          let availableFrom = ''
          let availableUntil = ''
          if (driver.startTimestamp) {
            let sinceTime = moment(since, 'X').format(ft.timeFormat(self, false))
            // availableFrom = moment(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY') + ' ' + sinceTime
            availableFrom = moment(driver.startTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false))
            availableUntil = moment(driver.endTimestamp, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY ' + ft.timeFormat(self, false))
          }
          drivers.push({
            id: driver.ID,
            name: name,
            firstName: driver.firstName,
            lastName: driver.lastName,
            licenseType: driver.accountType,
            homeSector: driver.homeSectorName || '',
            availableFrom: availableFrom,
            availableUntil: availableUntil,
            mobile: driver.phoneNumber || '',
          })
        })
        self.$store.commit('dispatch/setAvailableDriversData', {list: drivers})
        self.findNearbyDrivers()
      })
    },
    findNearbyDrivers (skipAvailability = false) {
      let self = this
      let run = this.runs.list.find(x => x.id === this.items[0].runId)
      if (self.driverFilter.isLoading || !this.items.length || !run) {
        return
      }
      // GET AVAILABLE DRIVERS - CROSS FILTER
      // if ((self.lastServiceAvailableCheck.id !== run.id ||
      //   (self.lastServiceAvailableCheck.id === run.id && self.lastServiceAvailableCheck.date.diff(moment(), 'minute') < -5)) &&
      //   !skipAvailability
      // ) {
      //   self.getAvailableDrivers({
      //     id: run.id,
      //     status: 'UPCOMING',
      //     pickupTime: run.pickupDate,
      //     lastDropoff: run.lastDropoff,
      //     serviceId: run.services[0].id,
      //   })
      //   return
      // }

      self.driverFilter.isLoading = true
      self.mapLoader = {
        show: true,
        label: 'FINDING NEARBY DRIVERS...'
      }

      if (self.sendTimerDelay) clearTimeout(self.sendTimerDelay)

      let serviceId = []
      serviceId.push(run.services[0].id)

      // Remove info bubble
      self.hereMaps.ui.getBubbles().forEach(bub => {
        self.hereMaps.ui.removeBubble(bub)
      })
      // Remove current drivers
      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id.indexOf('nearbyDrivers') > -1) {
          self.hereMaps.map.removeObject(object)
        }
      }

      self.lastDriverType = 'nearby'
      ApiDispatchDrivers.getNearbyDrivers(self, {
        token: self.$store.state.session.sessionToken,
        lat: run.pickup.lat,
        lng: run.pickup.lng,
        radius: self.driverFilter.miles,
        duty: 1,
        serviceTypeId: serviceId,
        order: 'distance',
        orderAsc: 1
      }, (r) => {
        self.driverFilter.isLoading = false
        self.mapLoader = {
          show: false,
          label: ''
        }
        self.$store.commit('runs/setNearByDrivers', {list: []})
        if (r.error) {
          // self.setCenter()
          return
        }

        if (!r.list.length) {
          self.driverFilter.show = true
          self.driverFilter.showToggle = true
          // self.setCenter()
          return
        }

        self.driverFilter.show = false
        self.showDriverInfoWindow = false

        let driversNearby = []
        for (let i = 0; i < r.list.length; i++) {
          let driver = r.list[i]
          // let isDriverAvailable = false
          // if (self.rsvpAvailableDrivers.length) {
          //   isDriverAvailable = self.rsvpAvailableDrivers.findIndex(x => x.id === driver.ID) > -1
          // }
          // if (typeof driver.tracks === 'undefined' || !isDriverAvailable) {
          //   continue
          // }
          let driverData = {
            id: driver.ID,
            phone: driver.phone,
            firstName: driver.firstName,
            lastName: driver.lastName,
            photoUrl: driver.avatarUrl,
            coords: {
              lat: driver.tracks.lat,
              lng: driver.tracks.lng,
              header: driver.tracks.heading
            },
            vehicle: {
              name: driver.vehicle.manufacturer + ' ' + driver.vehicle.model,
              licensePlate: driver.vehicle.licensePlate,
              photoUrl: driver.vehicle.photoUrl
            }
          }
          driversNearby.push(driverData)

          self.waiting.renderDriver.process = true
          self.waiting.renderDriver.data = driver
          self.driverDistance.push({
            id: driver.ID,
            distance: self.calculateDistance(
              {lat: driver.tracks.lat, lng: driver.tracks.lng},
              {lat: run.pickup.lat, lng: run.pickup.lng}
            )
          })
          self.currentDriver = driver
          if (i + 1 === r.list.length) {
            self.driverPresentation = true
            self.$store.commit('runs/setNearByDrivers', {list: driversNearby})
            // self.driverDistance = self.driverDistance.sort((a, b) => a.distance - b.distance)
            if (self.delayBeginDriverPresentation) {
              clearTimeout(self.delayBeginDriverPresentation)
            }
            self.delayBeginDriverPresentation = setTimeout(function () {
              self.beginDriverPresentation(true)
            }, 400)
          }

          self.searchStatus.miles = self.driverFilter.miles
        }
        if (!driversNearby.length) {
          self.driverFilter.show = true
          self.driverFilter.showToggle = true
        }
        // self.setDriverPin()
        self.driverPresented = []
        // self.setCenter()
      })
    },
    calculateDistance (coord1, coord2) {
      let toRad = value => value * Math.PI / 180
      let R = 6371
      let latD = toRad(coord2.lat - coord1.lat)
      let longD = toRad(coord2.lng - coord1.lng)
      let a = Math.sin(latD / 2) * Math.sin(latD / 2) +
        Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) *
        Math.sin(longD / 2) * Math.sin(longD / 2)
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
      let distance = R * c
      return distance / 1.609344
    },
    beginDriverPresentation (isNext) {
      let self = this

      if (self.doubleFix) {
        self.doubleFix = false
        return
      }
      self.doubleFix = true
      
      let driverData = self.runs.nearByDrivers.list
      // self.driverDistance = self.driverDistance.sort((a, b) => a.distance - b.distance)
      if (!self.driverDistance.length) {
        self.waiting.beginDriverPresentation = true
        return
      }

      if (!isNext && self.driverInfoIndex > 0) {
        self.driverInfoIndex--
      } else if (isNext && self.driverInfoIndex < driverData.length - 1) {
        self.driverInfoIndex++
        if (driverData[self.driverInfoIndex].id === self.currentDriver.id) self.driverInfoIndex++
      }
      if (driverData[self.driverInfoIndex]) {
        let index = driverData.findIndex(x => x.id === self.driverDistance[self.driverInfoIndex].id)
        if (index === -1) { index = 0 }
        self.showDriverInfo(driverData[index], true)
        // if (isNext) self.driverInfoIndex++
      } else {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'No more nearby drivers found.',
        })
      }
      self.setDriverPin()
    },
    showDriverInfo (driver, focus) {
      let self = this
      self.$store.commit('runs/setDriverInPopup', driver)

      // self.showDriverInfoWindow = true
      self.showDriverInfoWindow = false
      if (self.driverPresentation || typeof focus === 'undefined') {
        self.$nextTick(() => {
          self.showDriverInfoWindow = true
        })
      }

      if (focus) {
        self.setCenter('custom', {lat: driver.coords.lat, lng: driver.coords.lng})
      } else {
        self.driverPresentation = false
      }
      self.doubleFix = false
      self.updateDriverLocation(driver, false)
    },
    setCenter (type, data) {
      let self = this
      let group = new window.H.map.Group()

      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id === 'groupBound') {
          self.hereMaps.map.removeObject(object)
        }
      }

      let groupObject = []
      if (type === 'location') {
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id.indexOf('marker') > -1) {
            groupObject.push(new window.H.map.Circle(
              new window.H.geo.Point(object.lat, object.lng),
              5000,
              { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }
            ))
          }
        }
      } else if (type === 'driver') {
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id.indexOf('driverInMap') > -1 ||
            object.id.indexOf('nearbyDrivers') > -1
          ) {
            groupObject.push(new window.H.map.Circle(
              new window.H.geo.Point(object.lat, object.lng),
              5000,
              { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }
            ))
          }
        }
      } else if (type === 'custom') {
        groupObject.push(new window.H.map.Circle(
          new window.H.geo.Point(data.lat, data.lng),
          5000,
          { style: { fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)' } }
        ))
      }

      // Add to group for bounds correction
      if (groupObject.length) {
        group.addObjects(groupObject)
        group.id = 'groupBound'
        self.hereMaps.map.addObject(group)
  
        self.hereMaps.map.getViewModel().setLookAtData({
          bounds: group.getBoundingBox()
        })
      }
    },
    updateDriverLocation (driver, triggerPopup) {
      let self = this
      ApiDispatchDrivers.getLocation(self, driver.id, location => {
        if (location.error || (location && !location.list.length)) { return }
        let coords = {
          lat: location.list[0].lat,
          lng: location.list[0].lng
        }
        let run = this.runs.list.find(x => x.id === this.items[0].runId)

        driver.coords = coords
        if (triggerPopup) {
          self.showDriverInfo(driver, false)
          self.$store.commit('dispatch/removeDriverInMap', driver)
          self.$store.commit('dispatch/addDriverInMap', driver)
        } else {
          let routeCoords = [
            {lat: location.list[0].lat, lng: location.list[0].lng},
            {lat: run.pickup.lat, lng: run.pickup.lng}
          ]

          self.setRoute(routeCoords, {isDriverRoute: true, id: driver.id})
        }

        // if (self.rsvpInMap.id === null || self.rsvpInMap.driver === null) { return }
      })
    },
    setDriverPin (showOnly = false) {
      let self = this

      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id.indexOf('nearbyDrivers') > -1) {
          let id = parseInt(object.id.substring(13))
          let index = self.nearByDrivers.findIndex(x => x.id === id)
          if (index > -1) {
            self.hereMaps.map.removeObject(object)
            self.current.nearbyDrivers = self.current.nearbyDrivers.filter(driverId => {
              return driverId !== id
            })
          }
        }
      }

      let firstDriver = true
      self.nearByDrivers.forEach((driver, x) => {
        if (self.current.driversInMap.indexOf(driver.id) > -1) { return }

        let marker = '<svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">' +
          '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
          'stroke-width="{STROKE_WIDTH}" /></svg>'

        marker = marker.replace('{D}', mapPins.car.path)
          .replace('{FILL}', x == 0 ? '#38b550' : mapPins.car.fillColor)
          .replace('{STROKE}', mapPins.car.strokeColor)
          .replace('{STROKE_WIDTH}', x == 0 ? '.2' : mapPins.car.strokeWeight)

        let icon = new window.H.map.DomIcon(marker, {
          onAttach: (cloned, icon, marker) => {
            if (cloned) {
              cloned.addEventListener('click', evt => {
                self.displayDriverInfo(driver, 2, showOnly)
              })
            }
          },
          onDetach: (cloned, icon, marker) => {
            cloned.removeEventListener('click', evt => {})
          }
        })
        let coords = {lat: driver.coords.lat, lng: driver.coords.lng}
        let pin = new window.H.map.DomMarker(coords, {icon: icon})
        pin.id = 'nearbyDrivers' + driver.id
        pin.lat = driver.coords.lat
        pin.lng = driver.coords.lng
        self.current.nearbyDrivers.push(driver.id)
        self.hereMaps.map.addObject(pin)
        if (self.driverPresented.indexOf(driver.id) === -1 && firstDriver) {
          firstDriver = false
          self.driverPresented.push(driver.id)
          self.displayDriverInfo(driver, 3, showOnly)
        }
      })

      // for (let object of self.hereMaps.map.getObjects()) {
      //   if (object.id.indexOf('driverInMap') > -1) {
      //     let id = parseInt(object.id.substring(11))
      //     let index = self.driversInMap.findIndex(x => x.id === id)
      //     if (index === -1) {
      //       self.hereMaps.map.removeObject(object)
      //       self.current.driversInMap = self.current.driversInMap.filter(driverId => {
      //         return driverId !== id
      //       })
      //     }
      //   }
      // }

      // setTimeout(() => {
      //   self.driversInMap.forEach((driver, x) => {
      //     if (self.current.driversInMap.indexOf(driver.id) > -1) { return }

      //     let marker = '<svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">' +
      //       '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
      //       'stroke-width="{STROKE_WIDTH}" /></svg>'

      //     marker = marker.replace('{D}', mapPinsSettings.car.path)
      //       .replace('{FILL}', x == 0 ? '#38b550' : mapPinsSettings.car.fillColor)
      //       .replace('{STROKE}', mapPinsSettings.car.strokeColor)
      //       .replace('{STROKE_WIDTH}', x == 0 ? '.2' : mapPinsSettings.car.strokeWeight)

      //     let icon = new window.H.map.DomIcon(marker, {
      //       onAttach: (cloned, icon, marker) => {
      //         cloned.addEventListener('click', evt => {
      //           self.displayDriverInfo(driver, 4)
      //         })
      //       },
      //       onDetach: (cloned, icon, marker) => {
      //         cloned.removeEventListener('click', evt => {})
      //       }
      //     })
      //     let coords = {lat: driver.coords.lat, lng: driver.coords.lng}
      //     let pin = new window.H.map.DomMarker(coords, {icon: icon})
      //     pin.id = 'driverInMap' + driver.id
      //     pin.lat = driver.coords.lat
      //     pin.lng = driver.coords.lng
      //     self.current.driversInMap.push(driver.id)
      //     self.hereMaps.map.addObject(pin)
      //     if (firstDriver) {
      //       firstDriver = false
      //       self.displayDriverInfo(driver, 5)
      //     }
      //   })
      // }, 300)

      self.setCenter('driver', {})
    },
    displayDriverInfo (driver, x, showOnly = false) {
      let self = this

      // Display route from this driver
      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id.indexOf('driverRoute') > -1) {
          object.setVisibility(0)
          // if (object.id === 'driverRoute' + driver.id) {
          //   self.current.openDriver = driver.id
          //   object.setVisibility(1)
          // }
        }
      }

      // Remore existing info bubble
      self.hereMaps.ui.getBubbles().forEach(bub => {
        self.hereMaps.ui.removeBubble(bub)
      })

      let driverIndex = self.driverDistance.findIndex(x => x.id === driver.id)
      self.$store.commit('runs/setDriverInPopupRoute', self.driverDistance[driverIndex])

      let bubbleId = 'driverInfo_' + driver.id

      let bubbles = self.hereMaps.ui.getBubbles()
      for (let i = 0; i < bubbles.length; i++) {
        let item = bubbles[i]
        if (item.id !== bubbleId) {
          continue
        }
        self.hereMaps.ui.removeBubble(item)
      }

      let run = this.runs.list.find(x => x.id === this.items[0].runId)
      // let showDispatchButtons = run.id !== null && (run.status === 'UPCOMING' || run.status === 'REQUIRES DISPATCH') 
      let showDispatchButtons = true 

      let bubbleContent = '<div class="info-container">' +
        '<div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a></div>' +
        '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span></div>' +
        '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod">CALL {DRIVER_FNAME}</a>'
        '</div>'

      if (showDispatchButtons) {
        bubbleContent = '<div class="info-container">' +
          '<div class="prvNxt prev" id="driverPrev_{DRIVER_ID}"><i class="fas fa-chevron-left"></i></div>'+
          '<div class="prvNxt next" id="driverNext_{DRIVER_ID}"><i class="fas fa-chevron-right"></i></div>'+
          // '<div class="upcoming-rsvp">{UPCOMING_INFO}</div>' +
          '<div class="driver-info"><img src="{DRIVER_PHOTO}"/>' +
            '<a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a>' +
            '<span>{DRIVER_DISTANCE}</span>' +
            (!showOnly ? '<a id="DriverSend_{DRIVER_ID}" class="assign-button button cta xsmall warning block" href="javascript:;">SEND TO {DRIVER_FNAME}</a>' : '') +
          '</div>' +
          '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span>' +
            (!showOnly ? '<a id="DriverAssign_{DRIVER_ID}" class="assign-button button cta xsmall block" href="javascript:;">ASSIGN TO {DRIVER_FNAME}</a>' : '') + '</div>' +
          '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod"><i class="fas fa-phone"></i> CALL {DRIVER_FNAME}</a>'
          '</div>'

        let upcomingInfo = ''
        if (self.upcoming.loading) {
          upcomingInfo = '<i class="fa fa-spinner fa-spin"></i><span> Checking for upcoming reservations...</span>'
        } else if (!self.upcoming.loading && self.upcoming.rsvp === null) {
          upcomingInfo = 'No Upcoming Reservations.'
        } else if (!self.upcoming.loading && self.upcoming.rsvp !== null) {
          upcomingInfo = 'Upcoming '
          if (self.upcoming.rsvp !== null && self.upcoming.rsvp.type === 'package') {
            upcomingInfo = upcomingInfo + '<span>Package </span>' +
              ' (<a href="/#/package/' + self.upcoming.rsvp.data.package.id + '" target="_blank">' + self.upcoming.rsvp.data.package.id + '</a>) at ' +
              ' <span>' + self.formatTime(self.upcoming.rsvp.data.pickupTime) + '.</span>'
          }
          if (self.upcoming.rsvp !== null && self.upcoming.rsvp.type === 'rsvp') {
            upcomingInfo = upcomingInfo + '<span>RSVP </span>' +
              ' (<a href="/#/reservation/' + self.upcoming.rsvp.data.ID + '" target="_blank">' + self.upcoming.rsvp.data.ID + '</a>) at ' +
              ' <span>' + self.formatTime(self.upcoming.rsvp.data.pickupDate) + '.</span>'
          }
        }
        bubbleContent = bubbleContent.replace('{UPCOMING_INFO}', upcomingInfo)
      }

      self.currentDriver = driver
      bubbleContent = bubbleContent.replace('{DRIVER_PHOTO}', driver.photoUrl)
        .replaceAll('{DRIVER_ID}', driver.id)
        .replace('{DRIVER_URL}', '/#/provider/' + driver.id)
        .replace('{DRIVER_NAME}', driver.firstName + ' ' + driver.lastName)
        .replace('{DRIVER_DISTANCE}', self.driverRoutes['a' + driver.id] || '&nbsp;')
        .replace('{DRIVER_FNAME}', driver.firstName)
        .replace('{DRIVER_FNAME}', driver.firstName)
        .replace('{DRIVER_FNAME}', driver.firstName)
        .replace('{VEHICLE_PHOTO}', driver.vehicle.photoUrl)
        .replace('{VEHICLE_NAME}', driver.vehicle.name)
        .replace('{VEHICLE_NUMBER}', driver.vehicle.licensePlate)

      let bubble = new window.H.ui.InfoBubble({
        lat: driver.coords.lat,
        lng: driver.coords.lng
      }, {
        content: bubbleContent,
        onStateChange: aa => {
          if (self.delayBeginDriverPresentation) {
            clearTimeout(self.delayBeginDriverPresentation)
          }
          self.delayBeginDriverPresentation = setTimeout(function () {
            self.beginDriverPresentation(true)
          }, 500)
        }
      })
      bubble.id = bubbleId
      bubble.addClass('H_driver-info')
      self.hereMaps.ui.addBubble(bubble)
      
      let driverPrev = document.getElementById(`driverPrev_${driver.id}`)
      let driverNext = document.getElementById(`driverNext_${driver.id}`)
      let elem = document.getElementById('DriverCall_' + driver.id)
      let assignElem = document.getElementById('DriverAssign_' + driver.id)
      let sendElem = document.getElementById('DriverSend_' + driver.id)

      setTimeout(() => {
        if (driverPrev) {
          driverPrev.classList.remove('disabled')
          if (self.driverInfoIndex <= 0) {
            driverPrev.classList.add('disabled')
          } else {
            driverPrev.addEventListener('click', evt => {
              self.beginDriverPresentation(false)
            })
          }
        }
        if (driverNext) {
          let driverData = self.runs.nearByDrivers.list
          driverNext.classList.remove('disabled')
          if ((driverData.length - 1) <= self.driverInfoIndex) {
            driverNext.classList.add('disabled')
          } else {
            driverNext.addEventListener('click', evt => {
              self.beginDriverPresentation(true)
            })
          }
        }

        if (elem) {
          elem.addEventListener('click', evt => {
            self.callDriver(driver)
          })
        }

        if (showDispatchButtons) {
          if (assignElem) {
            assignElem.addEventListener('click', evt => {
              self.assignToDriver(driver)
            })
          }
          if (sendElem) {
            sendElem.addEventListener('click', evt => {
              self.sendToDriver(driver)
            })
          }
        }
      }, 500)
    },
    callDriver (driver) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      })
    },
    sendToDriver (driver) {
      let self = this
      // let run = this.runs.list.find(x => x.id === this.runs.selected)
      self.$store.commit('dispatch/showActionModal', 'Sending run to driver...')

      let customRequestTimeout = self.$settings.get('ASAPRequestTimeout')
      // if (self.modal.option === 'custom') customRequestTimeout = self.modal.custom
      let runId = self.runs.selected || self.runsInMap[0] 
      self.$sdk.post('/runs/send', {
        runId: runId,
        providerId: driver.id,
        token: self.$store.state.session.sessionToken,
        customRequestTimeout: customRequestTimeout
      }, r => {
        if (r.error) {
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong. Try again later.'
          })
        } else {
          self.$store.commit('runs/removeRunInTable', self.runs.selected)
          self.$store.commit('runs/addBlackList', self.runs.selected)
          self.$store.commit('runs/setRunsDetails', {selected: []})
          self.$store.commit('dispatch/setSelectedDriver', null)
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully sent run.'
          })

          self.$store.commit('runs/setSendTimer', {
            id: runId,
            time: self.$settings.get('DriverResponseTime') || 60
          })
        }
        self.$store.commit('runs/setRunsDetails', {refresh: true})
        setTimeout ( () => {
          self.$store.commit('dispatch/closeActionModal')
        }, 3000)
      }, '2.0')
    },
    assignToDriver (driver) {
      let self = this
      // let run = this.runs.list.find(x => x.id === this.runs.selected)

      self.$store.commit('dispatch/showActionModal', 'Assigning run to driver...')

      self.$sdk.post('/runs/assign', {
        runId: self.runs.selected || self.runsInMap[0],
        providerId: driver.id,
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          console.log('ERROR', r)
          self.$store.commit('dispatch/completeActionModal', {
            success: false,
            message: r.error.message ? r.error.message : 'Something went wrong.'
          })
        } else {
          self.$store.commit('dispatch/completeActionModal', {
            success: true,
            message: 'Successfully assigned items to driver.'
          })
          self.$store.commit('runs/setQualifiedDriversData', {refresh: true})
        }
        setTimeout ( () => {
          self.$store.commit('dispatch/closeActionModal')
        }, 3000)
      }, '2.0')
    },
    setRoute (items, extraData) {
      let self = this

      let url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&transportMode=car&return=polyline,summary'
      url = url.replace('{API_KEY}', CONFIG.hereApi.key)
      items.forEach((coords, index) => {
        if (index == 0) {
          url += `&origin=${coords.lat},${coords.lng}`
        } else if (index == items.length - 1) {
          url += `&destination=${coords.lat},${coords.lng}`
        } else {
          url += `&via=${coords.lat},${coords.lng}`
        }
      })
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          self.onCalculateError()
          return
        }
        self.onCalculateSuccess(extraData, body)
      })
    },
    onCalculateSuccess (extraData, result) {
      if (extraData.isTrackDriver) {
        this.setTrackDriverPin(result)
        return
      }
      if (!result.routes.length) return
      if (extraData.isDriverRoute) {
        let res = result.routes[0].sections[0].summary
        let distance = Math.round((res['length'] * .001) * 0.6214) + ' miles, ' + Math.round(res.duration / 60) + ' minutes away'
        if (res['length'] === 0 && res.duration === 0) {
          let tempElement = document.createElement('html')
          tempElement.innerHTML = res.text
          let miles = res.length
          let time = res.duration
          if (res.text) {
            miles = tempElement.getElementsByTagName('span')[0] ? tempElement.getElementsByTagName('span')[0].innerText : ''
            miles = Math.round(parseFloat(miles.substring(0, miles.length - 2)) * 0.6212)
            time = tempElement.getElementsByTagName('span')[1] ? tempElement.getElementsByTagName('span')[1].innerText : res.duration
            time = time.substring(0, time.length - 4)
          }

          distance = miles + ' miles, ' + time + ' minutes away'
        }
        this.driverRoutes['a' + extraData.id] = distance
      }
      var route = result.routes[0].sections
      this.addRouteShapeToMap(route, extraData)
    },
    onCalculateError (data) {
      console.error('ROUTING ERROR', data)
    },
    addRouteShapeToMap (routes, extraData, distance) {
      let self = this
      routes.forEach((route, index) => {
        let linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
        let polyline = new window.H.map.Polyline(linestring, {
          style: {
            lineWidth: 4,
            strokeColor: extraData.isDriverRoute ? '#2EE47D' : 'rgba(25, 25, 25, 0.7)'
          }
        });
        polyline.id = `rsvpRoute${index}`

        if (extraData.isDriverRoute) {
          for (let object of self.hereMaps.map.getObjects()) {
            if (object.id.indexOf('driverRoute') > -1) {
              object.setVisibility(0)
            }
          }
          polyline.id = 'driverRoute' + extraData.id
          polyline.setVisibility(1)

          let driverData = self.nearByDrivers
          let index = driverData.findIndex(x => x.id === extraData.id)
          if (index > -1) {
            self.displayDriverInfo(driverData[index], 1)
          }
        }
        this.hereMaps.map.addObject(polyline)
      })
      this.setCenter('location', {})
    },
    filterServices () {
      let self = this
      let services = this.$store.state.services

      if (!services.list.length) {
        this.getServices()
        return
      }

      self.driverFilter.services = []
      let run = this.runs.list.find(x => x.id === this.items[0].runId)
      services.list.forEach(service => {
        if (service.brandId === run.brandId) {
          self.driverFilter.services.push({
            id: service.id,
            brandId: run.brandId,
            name: service.label,
          })
        }
      })
      if (run.services[0] && run.services[0].id) {
        self.driverFilter.serviceTypes.push(run.services[0].id)
      }
    },
    getServices () {
      let self = this
      self.driverFilter.serviceLoading = true
      services.getAllService(self, r => {
        self.driverFilter.serviceLoading = false
        self.filterServices()
      })
    },

    findQualifiedDrivers () {
      let self = this
      if (!this.items.length || !this.items[0].runId) return

      self.mapLoader = {
        show: true,
        label: 'LOOKING FOR QUALIFIED DRIVERS...'
      }
      if (self.sendTimerDelay) clearTimeout(self.sendTimerDelay)
      self.lastDriverType = 'qualified'
      self.$sdk.get('/runs/queue', {
        token: self.$store.state.session.sessionToken,
        runId: self.items[0].runId
      }, r => {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          self.mapLoader = {
            show: false,
            label: ''
          }
          return
        }
        if (!r.list.length) {
          // self.noQualifiedDrivers()
          self.noQueueDrivers(r)
          return
        }

        self.$store.commit('runs/setQualifiedDriversData', {list: r.list})
        self.validateQualifiedDrivers(r)
        if (Object.keys(r.unqualified).length) self.buildReasons(r)
      }, '2.0')
    },
    checkRunSelected () {
      let self = this
      let isMultipleRun = false
      let runId = ''
      this.items.forEach(x => {
        if (!runId) runId = x.runId
        else if (runId && runId !== x.runId) {
          isMultipleRun = true
        }
      })

      if (isMultipleRun) {
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id.indexOf('qualifiedDrivers') > -1) {
            self.hereMaps.map.removeObject(object)
          }
        }
        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id.indexOf('driverRoute') > -1) {
            object.setVisibility(0)
          }
        }
        self.hereMaps.ui.getBubbles().forEach(bub => {
          self.hereMaps.ui.removeBubble(bub)
        })
      }

      return isMultipleRun
    },
    validateQualifiedDrivers (data) {
      let self = this
      if (!self.qualifiedDrivers.list.length || self.checkRunSelected()) {
        self.mapLoader = {show: false, label: ''}
        return
      }

      if (data) self.tmpProvData = data
      else if (self.tmpProvData) data = self.tmpProvData

      let driverId = self.qualifiedDrivers.list[0].id
      self.$sdk.get('/runs/validate', {
        token: self.$store.state.session.sessionToken,
        runId: self.items[0].runId,
        providerId: driverId
      }, r => {
        if (r.error) {
          self.$store.commit('runs/reduceQualifiedDrivers')

          let driver = ''
          if (data.unfiltered) driver = data.unfiltered.find(d => d.id == driverId)
          self.$store.commit('global/addReasonList', {
            id: driverId,
            name: driver ? driver.name : '',
            reason: r.error.message
          })
          // if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers()
          if (!self.qualifiedDrivers.list.length) self.noQueueDrivers(false)
          else self.validateQualifiedDrivers(data)
          // self.getDriverDetails(driverId, true)
          return
        }

        self.getDriverDetails(driverId)
      }, '2.0')
    },
    getDriverDetails (id, showOnly = false) {
      let self = this
      if (self.checkRunSelected()) return

      self.$sdk.get(`/provider/${id}`, {
        token: self.$store.state.session.sessionToken,
      }, r => {
        self.mapLoader = {
          show: false,
          label: ''
        }
        if (r.error) {
          if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers()
          else if (!showOnly) self.validateQualifiedDrivers()
          return
        }
        self.$store.commit('runs/setQualifiedDriversData', {
          details: {
            id: id,
            lat: self.qualifiedDrivers.list[0].home.lat,
            lng: self.qualifiedDrivers.list[0].home.lng,
            firstName: r.firstName,
            lastName: r.lastName,
            driverImg: r.avatarUrl,
            phone: `${r.countryCode }${r.phone}`,
            manafacturer: r.vehicle.manufacturer || '',
            model: r.vehicle.model || '',
            licensePlate: r.vehicle.licensePlate,
            carImg: r.vehicle.photo,
          }
        })
        self.$store.commit('runs/reduceQualifiedDrivers')
        self.setQualifiedDriverPin()
      })
    },
    noQualifiedDrivers () {
      // this.$store.commit('global/setAlertData', {
      //   show: true,
      //   message: 'No qualified drivers found.'
      // })
      this.mapLoader = {
        show: false,
        label: ''
      }
      this.queueError = {
        show: true,
        message: `No ${this.lastDriverType} drivers found.`,
      }
    },
    setQualifiedDriverPin () {
      let self = this
      if (self.checkRunSelected()) return

      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id.indexOf('qualifiedDrivers') > -1) {
          self.hereMaps.map.removeObject(object)
        }
      }
        
      let marker = '<svg height="25" width="25" style="overflow: overlay; top: -12px; left: -12px;" viewBox="0 0 50 50">' +
      '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
      'stroke-width="{STROKE_WIDTH}" /></svg>'

      marker = marker.replace('{D}', mapPins.house.path)
        .replace('{FILL}', '#F25E0D')
        .replace('{STROKE}', mapPins.house.strokeColor)
        .replace('{STROKE_WIDTH}', '.2')

      let driver = self.qualifiedDrivers.details
      let icon = new window.H.map.DomIcon(marker, {
        onAttach: (cloned, icon, marker) => {
          if (cloned) {
            cloned.addEventListener('click', evt => {
              self.displayQualifiedDriverInfo(driver, 2)
            })
          }
        },
        onDetach: (cloned, icon, marker) => {
          if (cloned) {
            cloned.removeEventListener('click', evt => {})
          }
        }
      })
      self.displayQualifiedDriverInfo(driver, 2)
      let coords = {lat: driver.lat, lng: driver.lng}
      let pin = new window.H.map.DomMarker(coords, {icon: icon})
      pin.id = 'qualifiedDrivers' + driver.id
      pin.lat = driver.lat
      pin.lng = driver.lng
      self.current.nearbyDrivers.push(driver.id)
      self.hereMaps.map.addObject(pin)

      self.setCenter('driver', {})
    },
    displayQualifiedDriverInfo (driver, x) {
      let self = this
      if (self.checkRunSelected()) return

      // Display route from this driver
      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id.indexOf('driverRoute') > -1) {
          object.setVisibility(0)
        }
      }

      // Remore existing info bubble
      self.hereMaps.ui.getBubbles().forEach(bub => {
        self.hereMaps.ui.removeBubble(bub)
      })

      let bubbleId = 'driverInfo_' + driver.id

      let bubbles = self.hereMaps.ui.getBubbles()
      for (let i = 0; i < bubbles.length; i++) {
        let item = bubbles[i]
        if (item.id !== bubbleId) {
          continue
        }
        self.hereMaps.ui.removeBubble(item)
      }

      // let run = this.runs.list.find(x => x.id === this.items[0].runId)
      let showDispatchButtons = true 

      let bubbleContent = '<div class="info-container">' +
        '<div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a></div>' +
        '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span></div>' +
        '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod">CALL {DRIVER_FNAME}</a>'
        '</div>'

      if (showDispatchButtons) {
        bubbleContent = '<div class="info-container">' +
          '<div class="prvNxt prev" id="driverPrev_{DRIVER_ID}"><i class="fas fa-chevron-left"></i></div>'+
          '<div class="prvNxt next" id="driverNext_{DRIVER_ID}"><i class="fas fa-chevron-right"></i></div>'+
          // '<div class="upcoming-rsvp">{UPCOMING_INFO}</div>' +
          '<div class="driver-info"><img src="{DRIVER_PHOTO}"/><a href="{DRIVER_URL}" target="_blank">{DRIVER_NAME}</a><span>{DRIVER_DISTANCE}</span>'+
            '<a id="DriverSend_{DRIVER_ID}" class="assign-button button cta xsmall warning block" href="javascript:;">SEND TO {DRIVER_FNAME}</a></div>' +
          '<div class="vehicle-info"><img src="{VEHICLE_PHOTO}"/><strong>{VEHICLE_NAME}</strong><span>{VEHICLE_NUMBER}</span>' +
            '<a id="DriverAssign_{DRIVER_ID}" class="assign-button button cta xsmall block" href="javascript:;">ASSIGN TO {DRIVER_FNAME}</a></div>' +
          '<a id="DriverCall_{DRIVER_ID}" class="call-button button cta xsmall success block" href="javascript:;" @click="testMethod"><i class="fas fa-phone"></i> CALL {DRIVER_FNAME}</a>'
          '</div>'

        let upcomingInfo = ''
        bubbleContent = bubbleContent.replace('{UPCOMING_INFO}', upcomingInfo)
      }

      self.currentDriver = driver
      bubbleContent = bubbleContent.replace('{DRIVER_PHOTO}', driver.driverImg)
        .replaceAll('{DRIVER_ID}', driver.id)
        .replace('{DRIVER_URL}', `/#/provider/${driver.id}`)
        .replace('{DRIVER_NAME}', `${driver.firstName} ${driver.lastName}`)
        .replace('{DRIVER_DISTANCE}', self.driverRoutes['a' + driver.id] || '&nbsp;')
        .replaceAll('{DRIVER_FNAME}', driver.firstName)
        .replace('{VEHICLE_PHOTO}', driver.carImg)
        .replace('{VEHICLE_NAME}', `${driver.manafacturer} ${driver.model}`)
        .replace('{VEHICLE_NUMBER}', driver.licensePlate)

      let bubble = new window.H.ui.InfoBubble({
        lat: driver.lat,
        lng: driver.lng
      }, {
        content: bubbleContent,
        onStateChange: aa => {
          // self.$store.commit('runs/reduceQualifiedDrivers')
          if (!self.qualifiedDrivers.list.length) self.noQualifiedDrivers()
          else self.validateQualifiedDrivers()
        }
      })
      bubble.id = bubbleId
      bubble.addClass('H_driver-info')
      self.hereMaps.ui.addBubble(bubble)

      setTimeout(() => {
        let elem = document.getElementById('DriverCall_' + driver.id)
        if (elem) {
          elem.addEventListener('click', evt => {
            self.callDriver(driver)
          })
        }

        if (showDispatchButtons) {
          let assignElem = document.getElementById('DriverAssign_' + driver.id)
          if (assignElem) {
            assignElem.addEventListener('click', evt => {
              self.assignToDriver(driver)
            })
          }
          let sendElem = document.getElementById('DriverSend_' + driver.id)
          if (sendElem) {
            sendElem.addEventListener('click', evt => {
              self.sendToDriver(driver)
            })
          }
        }
        self.checkRunSelected()
      }, 500)
    },
    driverFilterSubmit () {
      if (this.qualifiedDrivers.active) {
        this.findQualifiedDrivers()
        this.driverFilter.show = false
      } else {
        this.findNearbyDrivers()
      }
    },
    only1Run (item) {
      if (!item.length) return false
      let runId = ''
      let only1 = false
      item.forEach(x => {
        if (x.runId) {
          if (!runId) {
            runId = x.runId
            only1 = true
          } else if (x.runId !== runId) only1 = false
        }
      })

      return only1
    },
    noQueueDrivers (r = false) {
      this.mapLoader = {
        show: false,
        label: ''
      }
      this.queueError = {
        show: true,
        message: 'No qualified drivers found.',
      }
      if (r) this.buildReasons(r)
    },
    buildReasons (r) {
      let list = []
      for (const key of Object.keys(r.unqualified)) {
        if (r.unqualified[key][0] === 'services') continue
        let driver = r.unfiltered.find(d => d.id == key)
        if (driver) {
          list.push({
            id: driver.id,
            name: driver.name,
            reason: r.unqualified[key][0]
          })
        }
      }
      this.$store.commit('global/setReasonsData', {list: list})
    },
    showReasons () {
      this.queueError.show = false
      this.$store.commit('global/setReasonsData', {
        reasonsModal: true
      })
    },
    reasonLabel (x) {
      switch (x) {
        case 'serviceType': return 'Driver cannot accept this service type'
        case 'seats': return 'Driver vehcile does not have enough seat capacity'
        case 'adaWC': return 'Requires ADA wheelchair'
        case 'adaSD': return 'Requires ADA service dog'
        case 'fullTNC': return 'Do not give full TNC runs to TCP drivers'
        case 'availability': return 'Driver availability does not match'
        case 'distance': return 'Driver distance to first pickup location'
        default: return x
      }
    },
    closeReasons () {
      this.$store.commit('global/setReasonsData', {
        reasonsModal: false
      })
      this.$forceUpdate()
    }
  },
  watch: {
    items (value) {
      let self = this
      if (value.length <= 0) {
        _MapUtils.clearMap(self.hereMaps.map)

        for (let object of self.hereMaps.map.getObjects()) {
          if (object.id.indexOf('qualifiedDrivers') > -1) {
            self.hereMaps.map.removeObject(object)
          }
          if (object.id.indexOf('driverRoute') > -1) {
            object.setVisibility(0)
          }
        }
        self.hereMaps.ui.getBubbles().forEach(bub => {
          self.hereMaps.ui.removeBubble(bub)
        })
        self.$forceUpdate()
        return
      }
      self.renderMarkers()
      self.computeRoute()

      if (value.length) {
        let runId = []
        value.forEach(run => {
          if (run.runId && runId.indexOf(run.runId) == -1)  {
            runId.push(run.runId)
          }
        })
        if (runId.length == 1) {
          this.driverInfoIndex = 0
          // this.findNearbyDrivers()
        }
      }
      if (!this.checkRunSelected()) {
        let now = moment()
        let pickupTime = moment(value[0].pickupDate, 'MM/DD/YYYY hh:mmA')
        let diff = pickupTime.diff(now, 'minute')
        let limit = parseInt(self.$settings.get('findNearbyDriverLimit'))
        // self.upcoming.loading = true
        // self.upcoming.rsvp = null
        if (diff <= limit) {
          self.isQualifiedDriver = false
          self.$store.commit('runs/setQualifiedDriversData', {active: false})
          self.findNearbyDrivers()
        } else {
          self.isQualifiedDriver = true
          self.$store.commit('runs/setQualifiedDriversData', {active: true})
          self.findQualifiedDrivers()
        }
        // this.findQualifiedDrivers()
      }
    },
    'runs.selected': function (ids) {
      if (ids) {
        // this.driverInfoIndex = 0
        // this.findNearbyDrivers()
      }
    },
    driverDistance (value) {
      if (value && this.waiting.beginDriverPresentation) {
        this.waiting.beginDriverPresentation = false
      }
    },
    'driverFilter.show': function (val) {
      if (val) {
        this.filterServices()
      }
    }
  },
  mounted () {
    this.initMap()
  }
}
</script>

<style lang="scss" scoped>

.runs-map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .routing-map{ display:none; }
}

.map-here{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.map-loader{
  position: absolute;
  left: calc(50% - 125px);
  top: 20px;
  z-index: 2;
  background-color: #F25E0D;
  border-radius: 3px;
  padding: 5px 10px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  transition: all 250ms;
  opacity: 1;
  width: 250px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);

  &.hide {
    opacity: 0;
    top: -50px
  }
}

.search-status {
  position: absolute;
  top: 20px;
  left: calc(50% - 175px);
  width: 350px;
  background-color: #26D97A;
  color: #fff;
  text-align: center;
  font-size: 14px;
  padding: 5px 10px;
  font-weight: 700;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  border-bottom: 1px solid rgba(0,0,0,0.5);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 250ms;

  &.hide {
    top: -50px;
  }
}

.filter-toggle{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: #F4F8F9;
  color: #555;
  padding: 9px 10px 8px;
  border-bottom-right-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  transition: all 250ms;

  & i { line-height: inherit; }

  &.open {
    box-shadow: 0 2px 4px rgba(0,0,0,0);
    background-color: #0D79F2;
    color: #fff;
  }

  &.hide{
    top: -50px;
  }
}

.driver-filters{
  position: absolute;
  top: 0;
  left: 0;
  width: 350px;
  height: auto;
  z-index: 4;
  background-color: #F4F8F9;
  border-bottom-right-radius: 3px;
  overflow: hidden;
  box-shadow: 2px 2px 10px rgba(0,0,0,0.35);
  transition: all 250ms;

  &.hide{ top: -200%; }

  & .message{
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    padding: 14px;
    background-color: #0D79F2;
    color: #fff;
  }

  & .radius-input {
    padding: 10px 15px;

    & > * {
      vertical-align: middle;
    }
    & label {
      font-size: 12px;
      color: #8DA0A9;
      font-weight: 700;
    }

    & input {
      display: inline-block;
      width: 80px;
      padding: 10px;
      margin-top: 0;
      margin-right: 8px;
      font-size: 14px;
      line-height: 1;
      border: 1px solid rgba(0,0,0,0.3);
    }
  }

  & .service-types {
    padding: 0px 15px;

    .row{ padding-left: 25px; }
    & .title{
      font-size: 12px;
      color: #8DA0A9;
      font-weight: 700;
    }
    & label{
      & > * {
        display: inline-block;
        vertical-align: middle;
      }

      & input{
        width: auto;
        margin-top: 0;
      }

      & span{
        font-weight: 700;
        color: #777;
        margin-left: 5px;
      }
    }
  }

  & .divider{
    width: 80%;
    border-top: 1px solid rgba(0,0,0,0.2);
    margin: 15px auto;
  }

  & .button-wrapper{
    padding: 0 15px 15px;
  }

  .filter-note{
    padding: 10px;
    font-size: 14px;
    color: #93881e;
    background: #fff9c5;
    border: 1px solid #ccbd2f;
    border-radius: 4px;
    margin: 10px 20px 0;
    box-shadow: 1px 1px 2px rgba(0,0,0, .1);
  }
}
.cover{
  position: absolute;
  top: -500px; left: 0;
  width: 100%;
  // height: 100%;
  background-color: rgba(13, 121, 242, 0.8);
  z-index: 5;
  transition: all 250ms;

  &.show{
    top: 0;
  }

  & .cover-container{
    display: table;
    width: 100%;
    height: 100%;
  }

  & .cover-content {
    padding: 15px;
    font-weight: 700;
    color: #FFF;
    display: table-cell;
    vertical-align: middle;
    text-align: center;

    & .content{
      margin-top: 10px;
    }
  }
}

.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
  min-width: 300px;
  max-width: 500px;
}
.lr-alert-msg{
  margin-bottom: 20px;
  color: #45505b;
}
.show-reasons-btn{
  margin-top: 12px;
  font-size: 14px;
  color: #838689;
  text-decoration: underline;
  cursor: pointer;
}
.reasons-modal {
  &.hide{
    display: none;
  }
  .lr-box{
    width: 600px;
    max-width: 600px;
    max-height: calc(100vh - 40px);
    overflow: auto;
  }
}
.reason-table{
  width: 100%;
  max-width: 600px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
  th{
    background: #f3f3f3;
    padding: 4px;
    border-bottom: 1px solid #ccc;;
  }
  .driver{
    text-align: left;
  }
  .reason {
    text-align: right;
  }
  tr{
    td{
      border-bottom: 1px solid #ccc;
      font-size: 14px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Runs/Map.vue